import { ofType } from "redux-observable";
import { EMPTY } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { PersistenceMode } from "../../../utils/PersistenceMode";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionTutorial } from "../actionTutorial";
import { IdTutorialStep } from "../IdTutorialStep";
export var epicTutorialSelect = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTutorial.Select), switchMap(function (action) {
        utilPersistence.setValue(IdPersistence.Tutorial, {
            tutorialStep: action.tutorialStep,
        }, PersistenceMode.Write, true);
        if (action.tutorialStep === IdTutorialStep.tutorialCompleteConfirmation) {
            utilPersistence.setValue(IdPersistence.Tutorial, {}, PersistenceMode.Write, true);
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialSelect.ts
// module id = 2496
// module chunks = 3